module.exports = __webpack_public_path__ + "static/media/creditcardicon.80cde331.svg";